import React from "react";
import { Navbar } from "react-bootstrap";
import Footer from "../Components/Footer";

const ShippingAndDeliveryPolicy = () => {
  return (
    <>
      <Navbar />
      <div className="container my-5">
        <h2>Shipping and Delivery Policy</h2>
        <p>We ensure timely delivery of your orders. Please review our shipping policy for details.</p>

        <h4>1. Processing Time</h4>
        <p>Orders are processed within 1-3 business days after confirmation.</p>

        <h4>2. Delivery Time</h4>
        <p>Delivery time varies depending on the location. Standard shipping takes 5-7 business days.</p>

        <h4>3. Shipping Charges</h4>
        <p>Shipping charges are calculated at checkout based on the destination and product weight.</p>

        <h4>4. Delays</h4>
        <p>We are not responsible for delays due to natural disasters or unforeseen circumstances.</p>
      </div>
      <Footer />
    </>
  );
};

export default ShippingAndDeliveryPolicy;
